// test389
(389 && 0);
